import { z } from "zod"

// Для карты обязательны только id, название и координаты.
// Остальное — с безопасными значениями по умолчанию: у событий из парсеров
// (kassir, timepad и т.д.) нет организатора/участников, и раньше такие события
// молча выкидывались с карты.
export const schema = z.object({
  eventId: z.number(),
  eventAddress: z.object({
    city: z.string().nullish().transform(v => v ?? ""),
    street: z.string().nullish().transform(v => v ?? null),
    event_longitude: z.number(),
    event_latitude: z.number(),
    house_number: z.string().nullish().transform(v => v ?? null),
  }),
  avatarUrl: z.array(z.string()).nullish().transform(v => v ?? []),
  eventName: z.string(),
  eventType: z.string().nullish().transform(v => v ?? ""),
  organizerUsername: z.string().nullish().transform(v => v ?? ""),
  startTime: z.string().nullish().transform(v => v ?? ""),
  participants: z
    .array(z.object({ participant_avatar_url: z.string().nullish().transform(v => v ?? null) }))
    .nullish()
    .transform(v => v ?? []),
})

export const popupCardSchema = z.object({
  eventId: z.number(),
  eventAddress: z.string(),
  avatarUrl: z.array(z.string()),
  eventName: z.string(),
  startTime: z.string(),
  participants: z.array(z.string()),
})
